var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-app',{style:({ minHeight: ("calc(100vh - " + _vm.minimalNavigationHeight + "px)") }),attrs:{"id":_vm.setBackground}},[_c('minimal-navigation'),_c('router-view'),_c('app-notifications-snackbar')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }